/**
 * inbound actions are actions received by the extension.
 * outbound actions are actions emitted to the extension.
 */
export const inbound = {
	TEXTRECRUIT_DATA: 'TextRecruitData',
	DOMAIN_TO_EXCLUDE: 'TextRecruit.DomainToExclude',
	CURRENT_ORIGIN: 'TextRecruit.CurrentOrigin'
};

export const outbound = {
	RESUME_HIGHLIGHT: 'TextRecruit.ResumeHighlight',
	STOP_HIGHLIGHT: 'TextRecruit.StopHighlight',
	APP_READY: 'TextRecruit.AppReady',
	SET_PHONE_NUMBER_DETECTION: 'TextRecruit.SetPhoneNumberDetection',
	INCLUDE_DOMAIN: 'TextRecruit.IncludeDomain',
	EXCLUDE_DOMAIN: 'TextRecruit.ExcludeDomain'
};
